import React from "react";

function BarirSupport() {
  return (
    <div className="bg-[#eaf2f8] text-[#0d3b66] font-sans p-8 max-w-3xl mx-auto">
      <header className="text-center mb-8">
        <h1 className="text-3xl font-bold text-[#0d3b66]">Support</h1>
      </header>
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#ff6f61] mb-4">
          Contact Us
        </h2>
        <p className="text-lg leading-relaxed mb-4">
          If you need any assistance or have any questions about our game Barir,
          please feel free to reach out to us. We are here to help!
        </p>
        <p className="text-lg leading-relaxed">
          You can contact us via email at:
          <a href="mailto:tarbaa.kw@gmail.com" className="text-[#ffab40] ml-2">
            tarbaa.kw@gmail.com
          </a>
        </p>
      </section>
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#ff6f61] mb-4">
          Frequently Asked Questions
        </h2>
        <div className="mb-4">
          <h3 className="text-xl font-semibold text-[#0d3b66]">
            1. How do I play Barir?
          </h3>
          <p className="text-lg leading-relaxed">
            Barir is a game where you need to discover the imposter among the
            players. Start the game by selecting a category and the number of
            players, then follow the instructions to find out who the imposter
            is.
          </p>
        </div>
        <div className="mb-4">
          <h3 className="text-xl font-semibold text-[#0d3b66]">
            2. Is my data safe?
          </h3>
          <p className="text-lg leading-relaxed">
            Yes, Barir is a fully offline game and does not collect any personal
            data. For more details, please refer to our Privacy Policy.
          </p>
        </div>
        <div className="mb-4">
          <h3 className="text-xl font-semibold text-[#0d3b66]">
            3. How do I report a bug?
          </h3>
          <p className="text-lg leading-relaxed">
            If you encounter any issues or bugs while using Barir, please send a
            detailed email to
            <a
              href="mailto:tarbaa.kw@gmail.com"
              className="text-[#ffab40] ml-2"
            >
              tarbaa.kw@gmail.com
            </a>
            . Include as much information as possible so we can help resolve the
            issue.
          </p>
        </div>
      </section>
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#ff6f61] mb-4">Feedback</h2>
        <p className="text-lg leading-relaxed">
          We value your feedback and suggestions to improve Barir. Feel free to
          reach out to us at
          <a href="mailto:tarbaa.kw@gmail.com" className="text-[#ffab40] ml-2">
            tarbaa.kw@gmail.com
          </a>
          with any comments or ideas.
        </p>
      </section>
    </div>
  );
}

export default BarirSupport;
